import { __decorate, __param } from 'tslib';
import { CommonModule } from '@angular/common';
import { Injectable, InjectionToken, EventEmitter, NgZone, Inject, Output, Input, ViewChild, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { TranslateModule, NgxSharedModule } from '@mhe/ngx-shared';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngrx/store';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@mhe/ngx-shared/a11y-tooltip';
import * as ɵngcc4 from '@mhe/ngx-shared';

const _c0 = ["textarea"];
function EditorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "mhe-a11y-tooltip", 8);
    ɵngcc0.ɵɵelementStart(2, "a", 9);
    ɵngcc0.ɵɵlistener("click", function EditorComponent_div_0_Template_a_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.skipToEditor($event)); });
    ɵngcc0.ɵɵtext(3, "skip to input field");
    ɵngcc0.ɵɵelementEnd()();
} }
function EditorComponent_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.characterText);
} }
const _c1 = function (a0, a1, a2) { return { "below-character-limit": a0, "question-text": a1, "plain-text": a2 }; };
function EditorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, EditorComponent_div_1_span_2_Template, 2, 1, "span", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(4, _c1, ctx_r1.checkCharacterCount(ctx_r1.characterText), ctx_r1.characterText, !ctx_r1.useRichText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r1.maxCharacter - ctx_r1.characterCount, "/", ctx_r1.maxCharacter, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.characterText);
} }
function EditorComponent_div_3_mhe_rich_text_editor_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mhe-rich-text-editor", 14);
    ɵngcc0.ɵɵlistener("editorKeyup", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorKeyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r10.onRichTextEditorKeyup($event)); })("editorBlur", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorBlur_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r12.onEditorBlur()); })("pasteError", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_pasteError_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r13.onPasteError()); })("plainTextKeyup", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_plainTextKeyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r14.onRichTextEditorPlainTextKeyup($event)); })("escape", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_escape_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r15.onEscape()); })("editorKeydown", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorKeydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r16.onEditorKeydown($event)); })("editorKeypress", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorKeypress_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r17.onEditorKeypress($event)); })("editorMouseup", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorMouseup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r18.onEditorMouseup($event)); })("editorMousedown", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorMousedown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r19.onEditorMousedown($event)); })("editorMouseover", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorMouseover_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r20.onEditorMouseover($event)); })("editorChange", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r21.onEditorChange($event)); })("editorFocus", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorFocus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r22.onEditorFocus($event)); })("editorClick", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r23.onEditorClick($event)); })("editorNodeChange", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorNodeChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r24.onEditorNodeChange($event)); })("editorSetContent", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_editorSetContent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r25.onEditorSetContent($event)); })("loadComplete", function EditorComponent_div_3_mhe_rich_text_editor_1_Template_mhe_rich_text_editor_loadComplete_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r26.onEditorInit($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("content", ctx_r8.richValue)("noMedia", ctx_r8.noMedia)("imageOnly", ctx_r8.imageOnly)("maxCharacter", ctx_r8.maxCharacter)("basicMode", ctx_r8.basicMode)("toggleRichTextMenuBar", ctx_r8.toggleRichTextMenuBar)("tinymceMenubar", ctx_r8.tinymceMenubar)("elementPath", ctx_r8.elementPath)("init", ctx_r8.init)("hideAllHeaderBars", ctx_r8.hideAllHeaderBars)("isInputBox", ctx_r8.isInputBox)("focusOnLoad", ctx_r8.focusOnLoad)("customStyles", ctx_r8.customStyles);
} }
function EditorComponent_div_3_mhe_rich_text_editor_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mhe-rich-text-editor", 14);
    ɵngcc0.ɵɵlistener("editorKeyup", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorKeyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r27.onRichTextEditorKeyup($event)); })("editorBlur", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorBlur_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r29.onEditorBlur()); })("pasteError", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_pasteError_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r30.onPasteError()); })("plainTextKeyup", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_plainTextKeyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r31.onRichTextEditorPlainTextKeyup($event)); })("escape", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_escape_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r32.onEscape()); })("editorKeydown", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorKeydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r33 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r33.onEditorKeydown($event)); })("editorKeypress", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorKeypress_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r34.onEditorKeypress($event)); })("editorMouseup", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorMouseup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r35 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r35.onEditorMouseup($event)); })("editorMousedown", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorMousedown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r36 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r36.onEditorMousedown($event)); })("editorMouseover", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorMouseover_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r37.onEditorMouseover($event)); })("editorChange", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r38 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r38.onEditorChange($event)); })("editorFocus", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorFocus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r39 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r39.onEditorFocus($event)); })("editorClick", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r40 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r40.onEditorClick($event)); })("editorNodeChange", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorNodeChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r41 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r41.onEditorNodeChange($event)); })("editorSetContent", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_editorSetContent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r42 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r42.onEditorSetContent($event)); })("loadComplete", function EditorComponent_div_3_mhe_rich_text_editor_2_Template_mhe_rich_text_editor_loadComplete_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r43 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r43.onEditorInit($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("content", ctx_r9.richValue)("noMedia", ctx_r9.noMedia)("imageOnly", ctx_r9.imageOnly)("maxCharacter", ctx_r9.maxCharacter)("basicMode", ctx_r9.basicMode)("toggleRichTextMenuBar", ctx_r9.toggleRichTextMenuBar)("tinymceMenubar", ctx_r9.tinymceMenubar)("elementPath", ctx_r9.elementPath)("init", ctx_r9.init)("hideAllHeaderBars", ctx_r9.hideAllHeaderBars)("isInputBox", ctx_r9.isInputBox)("focusOnLoad", ctx_r9.focusOnLoad)("customStyles", ctx_r9.customStyles);
} }
function EditorComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, EditorComponent_div_3_mhe_rich_text_editor_1_Template, 1, 13, "mhe-rich-text-editor", 13);
    ɵngcc0.ɵɵtemplate(2, EditorComponent_div_3_mhe_rich_text_editor_2_Template, 1, 13, "mhe-rich-text-editor", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.render);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.render);
} }
const _c2 = function (a0) { return { "plain-text-editor-error": a0 }; };
function EditorComponent_textarea_4_Template(rf, ctx) { if (rf & 1) {
    const _r45 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "textarea", 15);
    ɵngcc0.ɵɵlistener("input", function EditorComponent_textarea_4_Template_textarea_input_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r44 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r44.onPlainTextKeyup($event.target.value)); })("blur", function EditorComponent_textarea_4_Template_textarea_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r46 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r46.onEditorBlur()); })("paste", function EditorComponent_textarea_4_Template_textarea_paste_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r47 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r47.onTextAreaPaste($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c2, ctx_r3.showErrors.length))("value", ctx_r3.plainValue || "");
    ɵngcc0.ɵɵattribute("maxlength", ctx_r3.maxCharacter || null);
} }
function EditorComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r48 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", error_r48, " ");
} }
const _c3 = function (a0) { return { "has-error": a0 }; };
const ZERO_KEY = 48;
const NINE_KEY = 57;
const DECIMAL_POINT_KEY = 110;
const PERIOD_KEY = 190;
const BACKSPACE_KEY = 8;
const DELETE_KEY = 46;
const NUMPAD_ZERO_KEY = 96;
const NUMPAD_NINE_KEY = 105;
const LEFT_ARROW_KEY = 37;
const RIGHT_ARROW_KEY = 38;
const UP_ARROW_KEY = 39;
const DOWN_ARROW_KEY = 40;
const TAB_KEY = 9;
const MINUS_KEY = 189;
const NUMBAD_MINUS_KEY = 109;
const ESC_KEY = 27;

let TextUtilityService = class TextUtilityService {
    stripHtmlTags(content) {
        const element = document.createElement('div');
        element.innerHTML = content;
        return element.innerText;
    }
    convertMathmlToSingleChar(content) {
        return content ? content.replace(/<math(.*?)<\/math>/g, ' ') : '';
    }
    isNumeric(event) {
        const eventKeyCode = event.keyCode || event.which;
        const allowedKeycodes = [
            BACKSPACE_KEY,
            LEFT_ARROW_KEY,
            RIGHT_ARROW_KEY,
            DELETE_KEY
        ];
        if (allowedKeycodes.includes(eventKeyCode) ||
            (eventKeyCode >= ZERO_KEY &&
                eventKeyCode <= NINE_KEY) ||
            (eventKeyCode >= NUMPAD_ZERO_KEY &&
                eventKeyCode <= NUMPAD_NINE_KEY) ||
            event.ctrlKey) {
            return true;
        }
        else {
            return false;
        }
    }
};
TextUtilityService.ɵfac = function TextUtilityService_Factory(t) { return new (t || TextUtilityService)(); };
TextUtilityService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TextUtilityService, factory: function (t) { return TextUtilityService.ɵfac(t); } });

const WIRIS_URL = new InjectionToken('WIRIS_URL');
const MMS_URL = new InjectionToken('MMS_URL');
const TINYMCE_SKINS_URL = new InjectionToken('TINYMCE_SKINS_URL');
const TINYMCE = new InjectionToken('TINYMCE');
const TINYMCE_EXTERNAL_PLUGINS = new InjectionToken('WIRTINYMCE_EXTERNAL_PLUGINSIS_URL');
const TINYMCE_TOOLBAR = new InjectionToken('TINYMCE_TOOLBAR');
const TINYMCE_MENUBAR = 'edit insert view format table tools';
const TINYMCE_PLUGINS = new InjectionToken('TINYMCE_PLUGINS');
const TINYMCE_HIDEA11YCHECKER = new InjectionToken('TINYMCE_HIDEA11YCHECKER');

const getState = createFeatureSelector('tinymce');
const ɵ0 = (state) => state;
const getTinymceConfig = createSelector(getState, ɵ0);

let RichTextEditorComponent = class RichTextEditorComponent {
    constructor(textUtilityService, _zone, tinymce, wirisUrl, mmsUrl, tinymceSkinsUrl, tinymceToolbar, tinymceExternalPlugins, tinymcePlugins, hideA11yChecker, store) {
        this.textUtilityService = textUtilityService;
        this._zone = _zone;
        this.tinymce = tinymce;
        this.wirisUrl = wirisUrl;
        this.mmsUrl = mmsUrl;
        this.tinymceSkinsUrl = tinymceSkinsUrl;
        this.tinymceToolbar = tinymceToolbar;
        this.tinymceExternalPlugins = tinymceExternalPlugins;
        this.tinymcePlugins = tinymcePlugins;
        this.hideA11yChecker = hideA11yChecker;
        this.store = store;
        this.editorKeyup = new EventEmitter();
        this.editorKeydown = new EventEmitter();
        this.editorKeypress = new EventEmitter();
        this.editorMouseup = new EventEmitter();
        this.editorMouseover = new EventEmitter();
        this.editorMousedown = new EventEmitter();
        this.editorBlur = new EventEmitter();
        this.editorClick = new EventEmitter();
        this.editorFocus = new EventEmitter();
        this.editorChange = new EventEmitter();
        this.editorNodeChange = new EventEmitter();
        this.plainTextKeyup = new EventEmitter();
        this.pasteError = new EventEmitter();
        this.editorSetContent = new EventEmitter();
        this.loadComplete = new EventEmitter();
        this.content = '';
        this.customStyles = {};
        this.hideAllHeaderBars = false;
        this.isInputBox = false;
        this.focusOnLoad = false;
        this.hasInitializedEditor = false;
        this.store.select(getTinymceConfig)
            .pipe(take(1))
            .subscribe((tinymceConfig) => {
            if (tinymceConfig) {
                if (tinymceConfig.wirisUrl) {
                    this.wirisUrl = tinymceConfig.wirisUrl;
                }
                if (tinymceConfig.mmsUrl) {
                    this.mmsUrl = tinymceConfig.mmsUrl;
                }
                if (tinymceConfig.tinymceSkinsUrl) {
                    this.tinymceSkinsUrl = tinymceConfig.tinymceSkinsUrl;
                }
                if (tinymceConfig.tinymceExternalPlugins) {
                    this.tinymceExternalPlugins = tinymceConfig.tinymceExternalPlugins;
                }
                if (tinymceConfig.hideA11yChecker) {
                    this.hideA11yChecker = tinymceConfig.hideA11yChecker;
                }
            }
        });
    }
    ngAfterViewInit() {
        if (this.wirisUrl) {
            this.tinymce.wirisUrl = this.wirisUrl;
        }
        this.tinymce.mmsUrl = this.mmsUrl;
        setTimeout(() => {
            this.tinymce.init(Object.assign(Object.assign({}, this.init), { branding: false, entity_encoding: 'raw', target: this.textarea.nativeElement, external_plugins: (this.init && this.init.external_plugins) || this.getExternalPlugins(), plugins: (this.init && this.init.plugins) || this.getPlugins(), browser_spellcheck: this.getBrowserSpellCheck(), menubar: this.getMenuBar(), toolbar: this.getToolbar(), 
                // skin_url:(this.init && this.init.skin_url) || this.tinymceSkinsUrl, // temp fix until plugin updates to 5.x
                setup: editor => this.setup(editor), file_picker_types: (this.init && this.init.file_picker_types) || 'file image media', file_picker_callback: (this.init && this.init.file_picker_callback) || this.filePickerCallback.bind(this), default_link_target: (this.init && this.init.default_link_target) || '_blank', target_list: (this.init && this.init.target_list) || false, image_title: this.getImageTitle(), anchor_top: (this.init && this.init.anchor_top) || false, anchor_bottom: (this.init && this.init.anchor_bottom) || false, elementpath: (this.init && this.init.elementPath) || this.elementPath }));
        }, 0);
    }
    ngOnDestroy() {
        this.tinymce.remove(this.editor);
    }
    ngOnChanges(changes) {
        if (changes.content &&
            this.hasInitializedEditor &&
            this.content !== this.editor.getContent()) {
            this.updateEditorContent();
        }
    }
    filePickerCallback(cb, value, meta) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('id', 'files');
        if (meta.filetype === 'file') {
            input.setAttribute('accept', '.txt');
        }
        else if (meta.filetype === 'image') {
            input.setAttribute('accept', 'image/*');
        }
        else if (meta.filetype === 'media') {
            input.setAttribute('accept', 'audio/mpeg');
        }
        input.onchange = () => {
            const file = input.files[0];
            if (meta.filetype === 'media') {
                this.editor.editorUpload.media = file;
            }
            else {
                this.editor.editorUpload.file = file; // for image and transcript
            }
            cb(file.name, { title: file.name });
        };
        input.click();
    }
    updateEditorContent() {
        this.editor.setContent(this.content || '');
    }
    setup(editor) {
        this.editor = editor;
        // this is to append the setup if provided in the init(mainly for adding custom tools, icons)
        if (this.init && typeof this.init.setup === 'function') {
            this.init.setup(editor);
        }
        this.setupListener('init', () => this.onEditorInit());
        this.setupListener('keyup change', () => this.onEditorChange(event));
        this.setupListener('keydown', event => this.onEditorKeydown(event));
        this.setupListener('paste', event => this.onEditorPaste(event));
        this.setupListener('focus', event => this.onEditorFocus(event));
        this.setupListener('blur', event => this.onEditorBlur(event));
        this.setupListener('click', event => this.onEditorClick(event));
        this.setupListener('mouseup', event => this.onEditorMouseup(event));
        this.setupListener('mousedown', event => this.onEditorMousedown(event));
        this.setupListener('mouseover', event => this.onEditorMouseover(event));
        this.setupListener('nodechange', event => this.onEditorNodeChange(event));
        this.setupListener('setContent', event => this.onEditorSetContent(event));
    }
    onEditorInit() {
        if (this.toggleRichTextMenuBar) {
            this.hideMenubar();
        }
        this.loadComplete.emit(true);
        this.updateEditorContent();
        this.hasInitializedEditor = true;
        if (this.focusOnLoad) {
            this.focusOnEditor();
        }
        if (this.isInputBox) {
            const iframeContainer = this.editor.contentAreaContainer.getElementsByTagName('iframe')[0].contentDocument;
            iframeContainer.getElementsByClassName('mce-content-body')[0].style.whiteSpace = 'nowrap';
            iframeContainer.getElementsByClassName('mce-content-body')[0].style.overflowX = 'hidden';
        }
        this.highlightContainer(false);
        return true;
    }
    onEditorChange(event) {
        const editor = this.editor;
        const richContent = editor.getContent();
        const plainTextContent = editor.getContent({ format: 'text' });
        this.editorChange.emit(event);
        if (richContent === this.content ||
            richContent === this.lastEmittedContent) {
            return false;
        }
        else if (this.isOverLimit()) {
            this.editor.setContent(this.content);
            return false;
        }
        this.editorKeyup.emit(editor);
        this.plainTextKeyup.emit(plainTextContent);
        this.lastEmittedContent = richContent;
        return true;
    }
    onEditorSetContent(event) {
        this.editorSetContent.emit(event);
        return true;
    }
    onEditorKeydown(event) {
        this.editorKeydown.emit(event);
        this.selectedContent = this.editor.selection.getContent({ format: 'text' }) || '';
        if (this.isInputBox && event.key === 'Enter') {
            event.preventDefault();
        }
        return (!this.isCharacterLimitReached() || this.isAllowedKeydownOverLimit(event));
    }
    onEditorPaste(event) {
        const copiedContent = (window['clipboardData'] && window['clipboardData'].getData('Text')) ||
            event.clipboardData.getData('Text');
        const copiedContentLength = this.lengthIgnoringHtmlTags(copiedContent);
        const editorContentLength = this.lengthIgnoringHtmlTags(this.editor.getContent());
        const selectedContentLength = this.lengthIgnoringHtmlTags(this.selectedContent);
        const lengthAfterPaste = copiedContentLength + editorContentLength - selectedContentLength;
        if (lengthAfterPaste > this.maxCharacter) {
            this.pasteError.emit();
            return false;
        }
        return true;
    }
    onEditorFocus(event) {
        this.editorFocus.emit(event);
        if (this.toggleRichTextMenuBar) {
            this.showMenubar();
        }
        return true;
    }
    onEditorBlur(event) {
        this.editorBlur.emit();
        setTimeout(() => {
            if (this.toggleRichTextMenuBar) {
                this.hideMenubar();
            }
        }, 200);
        return true;
    }
    onEditorClick(event) {
        this.editorClick.emit(event);
        return true;
    }
    onEditorMouseup(event) {
        this.editorMouseup.emit(event);
        return true;
    }
    onEditorMousedown(event) {
        this.editorMousedown.emit(event);
        return true;
    }
    onEditorMouseover(event) {
        this.editorMouseover.emit(event);
        return true;
    }
    onEditorNodeChange(event) {
        this.editorNodeChange.emit(event);
        return true;
    }
    focusOnEditor() {
        this.editor.focus();
    }
    highlightContainer(hasError) {
        const editor = this.editor;
        if (editor && editor.editorContainer) {
            this.setStyle();
            editor.editorContainer.style.borderColor = hasError ? '#b0181e' : this.customStyles.borderColor || '#c5c5c5';
        }
    }
    setStyle() {
        const editor = this.editor;
        if (editor && editor.editorContainer) {
            const customStyles = this.customStyles;
            Object.keys(customStyles)
                .forEach(key => {
                editor.editorContainer.style[key] = customStyles[key];
            });
        }
    }
    showMenubar() {
        if (this.hideAllHeaderBars) {
            return;
        }
        this.editor.contentAreaContainer.offsetParent.getElementsByClassName('tox-editor-header')[0].style.display = 'block';
        if (!this.isInputBox) {
            this.editor.contentAreaContainer.offsetParent.getElementsByClassName('tox-statusbar')[0].style.display = 'block';
        }
    }
    hideMenubar() {
        const contentAreaContainer = this.editor.contentAreaContainer && this.editor.contentAreaContainer.offsetParent;
        const isBarPresent = contentAreaContainer && contentAreaContainer.getElementsByClassName('tox-editor-header')[0]
            && contentAreaContainer.getElementsByClassName('tox-statusbar')[0];
        if (!isBarPresent) {
            return;
        }
        contentAreaContainer.getElementsByClassName('tox-editor-header')[0].style.display = 'none';
        contentAreaContainer.getElementsByClassName('tox-statusbar')[0].style.display = 'none';
    }
    setupListener(events, callback) {
        this.editor.on(events, (event) => {
            let result = false;
            this._zone.run(() => {
                result = callback(event);
            });
            return result;
        });
    }
    isOverLimit() {
        return this.lengthIgnoringHtmlTags(this.editor.getContent()) > this.maxCharacter;
    }
    isCharacterLimitReached() {
        return this.lengthIgnoringHtmlTags(this.editor.getContent()) > this.maxCharacter - 1;
    }
    lengthIgnoringHtmlTags(content) {
        const textUtilityService = this.textUtilityService;
        const modifiedContent = textUtilityService.convertMathmlToSingleChar(content);
        const plainTextContent = textUtilityService.stripHtmlTags(modifiedContent);
        return plainTextContent.length;
    }
    isAllowedKeydownOverLimit(event) {
        const eventKeyCode = event.keyCode || event.which;
        const allowedKeycodes = [
            BACKSPACE_KEY,
            DELETE_KEY,
            LEFT_ARROW_KEY,
            RIGHT_ARROW_KEY,
            UP_ARROW_KEY
        ];
        return allowedKeycodes.includes(eventKeyCode) || event.ctrlKey;
    }
    getPlugins() {
        let plugins = [
            'link',
            'paste',
            'table',
            'lists',
            'code',
            'charmap, advlist',
            'fullscreen',
            // 'languageByPart',  // paid and custom plugins
            // 'a11ychecker',
            // 'textcolor', //outdated plugins
            // 'colorpicker',
            'searchreplace'
        ];
        plugins = this.noMedia ? plugins : plugins.concat(['media', 'image']);
        // plugins = this.imageOnly ? plugins.concat(['choiceImage']) : plugins; //temp fix until plugin updates to 5.x
        plugins = this.imageOnly ? plugins.concat(['image']) : plugins;
        plugins = this.wirisUrl ? plugins.concat(['tiny_mce_wiris']) : plugins;
        // plugins = this.hideA11yChecker
        // ? plugins.filter(plugin => plugin !== 'a11ychecker')
        // : plugins; // temp fix until plugin updates to 5.x
        return this.tinymcePlugins || plugins;
    }
    getExternalPlugins() {
        return this.tinymceExternalPlugins;
    }
    getToolbar() {
        if (this.init) {
            if (this.init.toolbar === false) {
                return false;
            }
            else if (this.init.toolbar) {
                return this.init.toolbar;
            }
        }
        const basicToolbar = 'undo redo | formatselect | bold italic underline';
        let toolbar = 'undo redo | searchreplace fontsizeselect bold italic underline strikethrough' +
            ' superscript subscript | forecolor backcolor | bullist numlist | alignleft aligncenter alignright' +
            ' alignjustify | outdent indent | table ';
        toolbar = this.noMedia ? toolbar : toolbar + 'media image ';
        toolbar = this.imageOnly ? toolbar + 'image ' : toolbar;
        // toolbar + 'tiny_mce_wiris_formulaEditor charmap link code fullscreen'; // Fixed
        return this.basicMode ? basicToolbar : this.tinymceToolbar || toolbar;
    }
    getMenuBar() {
        if (this.init) {
            if (this.init.menubar === false) {
                return false;
            }
            else if (this.init.menubar) {
                return this.init.menubar;
            }
        }
        else {
            return this.basicMode ? '' : this.tinymceMenubar || TINYMCE_MENUBAR;
        }
    }
    getImageTitle() {
        if (this.init) {
            if (this.init.image_title === false) {
                return false;
            }
            else if (this.init.image_title) {
                return this.init.image_title;
            }
        }
        else {
            return true;
        }
    }
    getBrowserSpellCheck() {
        if (this.init) {
            if (this.init.browser_spellcheck === false) {
                return false;
            }
            else if (this.init.browser_spellcheck) {
                return this.init.browser_spellcheck;
            }
        }
        else {
            return true;
        }
    }
};
RichTextEditorComponent.ɵfac = function RichTextEditorComponent_Factory(t) { return new (t || RichTextEditorComponent)(ɵngcc0.ɵɵdirectiveInject(TextUtilityService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(TINYMCE), ɵngcc0.ɵɵdirectiveInject(WIRIS_URL), ɵngcc0.ɵɵdirectiveInject(MMS_URL), ɵngcc0.ɵɵdirectiveInject(TINYMCE_SKINS_URL), ɵngcc0.ɵɵdirectiveInject(TINYMCE_TOOLBAR), ɵngcc0.ɵɵdirectiveInject(TINYMCE_EXTERNAL_PLUGINS), ɵngcc0.ɵɵdirectiveInject(TINYMCE_PLUGINS), ɵngcc0.ɵɵdirectiveInject(TINYMCE_HIDEA11YCHECKER), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Store)); };
RichTextEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RichTextEditorComponent, selectors: [["mhe-rich-text-editor"]], viewQuery: function RichTextEditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
    } }, inputs: { content: "content", customStyles: "customStyles", hideAllHeaderBars: "hideAllHeaderBars", isInputBox: "isInputBox", focusOnLoad: "focusOnLoad", init: "init", maxCharacter: "maxCharacter", noMedia: "noMedia", imageOnly: "imageOnly", toggleRichTextMenuBar: "toggleRichTextMenuBar", elementPath: "elementPath", basicMode: "basicMode", tinymceMenubar: "tinymceMenubar" }, outputs: { editorKeyup: "editorKeyup", editorKeydown: "editorKeydown", editorKeypress: "editorKeypress", editorMouseup: "editorMouseup", editorMouseover: "editorMouseover", editorMousedown: "editorMousedown", editorBlur: "editorBlur", editorClick: "editorClick", editorFocus: "editorFocus", editorChange: "editorChange", editorNodeChange: "editorNodeChange", plainTextKeyup: "plainTextKeyup", pasteError: "pasteError", editorSetContent: "editorSetContent", loadComplete: "loadComplete" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["textarea", ""]], template: function RichTextEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "textarea", null, 0);
    } }, styles: ["[_nghost-%COMP%]     [aria-label=\"Font Sizes\"] button{width:65px}"], changeDetection: 0 });
RichTextEditorComponent.ctorParameters = () => [
    { type: TextUtilityService },
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: [TINYMCE,] }] },
    { type: String, decorators: [{ type: Inject, args: [WIRIS_URL,] }] },
    { type: String, decorators: [{ type: Inject, args: [MMS_URL,] }] },
    { type: String, decorators: [{ type: Inject, args: [TINYMCE_SKINS_URL,] }] },
    { type: String, decorators: [{ type: Inject, args: [TINYMCE_TOOLBAR,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TINYMCE_EXTERNAL_PLUGINS,] }] },
    { type: Array, decorators: [{ type: Inject, args: [TINYMCE_PLUGINS,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TINYMCE_HIDEA11YCHECKER,] }] },
    { type: Store }
];
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorKeyup", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorKeydown", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorKeypress", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorMouseup", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorMouseover", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorMousedown", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorBlur", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorClick", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorFocus", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorChange", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorNodeChange", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "plainTextKeyup", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "pasteError", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "editorSetContent", void 0);
__decorate([
    Output()
], RichTextEditorComponent.prototype, "loadComplete", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "init", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "content", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "maxCharacter", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "noMedia", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "imageOnly", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "toggleRichTextMenuBar", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "elementPath", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "basicMode", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "tinymceMenubar", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "customStyles", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "hideAllHeaderBars", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "isInputBox", void 0);
__decorate([
    Input()
], RichTextEditorComponent.prototype, "focusOnLoad", void 0);
__decorate([
    ViewChild('textarea', { static: true })
], RichTextEditorComponent.prototype, "textarea", void 0);
RichTextEditorComponent = __decorate([ __param(2, Inject(TINYMCE)),
    __param(3, Inject(WIRIS_URL)),
    __param(4, Inject(MMS_URL)),
    __param(5, Inject(TINYMCE_SKINS_URL)),
    __param(6, Inject(TINYMCE_TOOLBAR)),
    __param(7, Inject(TINYMCE_EXTERNAL_PLUGINS)),
    __param(8, Inject(TINYMCE_PLUGINS)),
    __param(9, Inject(TINYMCE_HIDEA11YCHECKER))
], RichTextEditorComponent);

const PASTE_ERROR_MESSAGE = 'The content exceeds the character limit.';

let EditorComponent = class EditorComponent {
    constructor(textUtilityService) {
        this.textUtilityService = textUtilityService;
        this.contentChange = new EventEmitter();
        this.pasteError = new EventEmitter();
        this.escape = new EventEmitter();
        this.editorFocusOut = new EventEmitter();
        this.editorKeyup = new EventEmitter();
        this.editorKeydown = new EventEmitter();
        this.editorKeypress = new EventEmitter();
        this.editorMouseup = new EventEmitter();
        this.editorMouseover = new EventEmitter();
        this.editorMousedown = new EventEmitter();
        this.editorBlur = new EventEmitter();
        this.editorClick = new EventEmitter();
        this.editorFocus = new EventEmitter();
        this.editorChange = new EventEmitter();
        this.editorNodeChange = new EventEmitter();
        this.editorSetContent = new EventEmitter();
        this.plainTextKeyup = new EventEmitter();
        this.loadComplete = new EventEmitter();
        this.useRichText = true;
        this.noMedia = false;
        this.imageOnly = false;
        this.toggleRichTextMenuBar = true;
        this.elementPath = true;
        this.basicMode = false;
        this.showCharacterLimit = true;
        this.useA11yTooltip = false;
        this.errors = [];
        this.hideAllHeaderBars = false;
        this.isInputBox = false;
        this.focusOnLoad = false;
        this.customStyles = {};
        this.render = true;
        this.richValue = '';
        this.plainValue = '';
        this.pasteErrorMessage = PASTE_ERROR_MESSAGE;
        this.characterCount = 0;
        this.hasPasteError = false;
    }
    ngOnInit() {
        this.plainValue = this.plainValue || this.content;
        this.setRichValue(this.richValue || this.content);
    }
    ngOnChanges() {
        this.plainValue = this.content;
        this.setRichValue(this.content);
        this.highlightContainer();
    }
    onEditorBlur() {
        this.editorFocusOut.emit(this.content);
    }
    onRichTextEditorKeyup(editor) {
        this.setRichValue(editor.getContent());
        if (editor.hasMath) {
            editor.hasMath = false;
            this.rerender();
        }
        this.emitCurrentValue();
        this.hasPasteError = false;
    }
    onRichTextEditorPlainTextKeyup(value) {
        this.plainValue = value;
    }
    onPlainTextKeyup(value) {
        this.plainValue = value;
        this.richValue = value;
        this.characterCount = this.plainValue.length;
        this.emitCurrentValue();
        this.hasPasteError = false;
    }
    setRichValue(value) {
        this.richValue = value;
        this.characterCount = this.lengthIgnoringHtmlTags(value);
    }
    emitCurrentValue() {
        this.useRichText
            ? this.contentChange.emit(this.richValue)
            : this.contentChange.emit(this.plainValue);
    }
    lengthIgnoringHtmlTags(content) {
        const textUtilityService = this.textUtilityService;
        const modifiedContent = textUtilityService.convertMathmlToSingleChar(content);
        const plainTextContent = textUtilityService.stripHtmlTags(modifiedContent);
        return plainTextContent.length;
    }
    checkCharacterCount(showCharacterText) {
        const percentage = showCharacterText ? 100 : 10;
        return (this.maxCharacter - this.characterCount <= this.maxCharacter / percentage);
    }
    onPasteError() {
        this.pasteError.emit();
        this.hasPasteError = true;
        this.highlightContainer();
    }
    onTextAreaPaste(e) {
        const data = e.clipboardData.getData('Text');
        if (!this.maxCharacter) {
            return true;
        }
        const isLongerThanMaxCharLength = data.length + this.lengthIgnoringHtmlTags(e.target.value) >
            this.maxCharacter;
        if (isLongerThanMaxCharLength) {
            this.onPasteError();
            return false;
        }
        return true;
    }
    rerender() {
        this.render = false;
        setTimeout(() => {
            this.render = true;
        });
    }
    onEscape() {
        this.escape.emit();
    }
    skipToEditor(event) {
        event.preventDefault();
        this.richTextEditorComponent.focusOnEditor();
    }
    get showErrors() {
        return this.pasteErrorMessage && this.hasPasteError
            ? this.errors.concat(this.pasteErrorMessage)
            : this.errors;
    }
    onEditorKeydown(event) {
        this.editorKeydown.emit(event);
    }
    onEditorKeypress(event) {
        this.editorKeypress.emit(event);
    }
    onEditorMouseup(event) {
        this.editorMouseup.emit(event);
    }
    onEditorMousedown(event) {
        this.editorMousedown.emit(event);
    }
    onEditorMouseover(event) {
        this.editorMouseover.emit(event);
    }
    onEditorChange(event) {
        this.editorChange.emit(event);
    }
    onEditorFocus(event) {
        this.editorFocus.emit(event);
    }
    onEditorClick(event) {
        this.editorClick.emit(event);
    }
    onEditorNodeChange(event) {
        this.editorNodeChange.emit(event);
    }
    onEditorInit(event) {
        this.loadComplete.emit(event);
    }
    onEditorSetContent(event) {
        this.editorSetContent.emit(event);
        this.characterCount = this.lengthIgnoringHtmlTags(event.content);
        if (this.characterCount === 0) {
            this.hasPasteError = false;
        }
    }
    highlightContainer() {
        if (this.richTextEditorComponent && Array.isArray(this.showErrors)) {
            this.richTextEditorComponent.highlightContainer(!!this.showErrors.length);
        }
    }
};
EditorComponent.ɵfac = function EditorComponent_Factory(t) { return new (t || EditorComponent)(ɵngcc0.ɵɵdirectiveInject(TextUtilityService)); };
EditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditorComponent, selectors: [["mhe-editor"]], viewQuery: function EditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(RichTextEditorComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.richTextEditorComponent = _t.first);
    } }, inputs: { useRichText: "useRichText", noMedia: "noMedia", imageOnly: "imageOnly", toggleRichTextMenuBar: "toggleRichTextMenuBar", elementPath: "elementPath", basicMode: "basicMode", showCharacterLimit: "showCharacterLimit", useA11yTooltip: "useA11yTooltip", errors: "errors", hideAllHeaderBars: "hideAllHeaderBars", isInputBox: "isInputBox", focusOnLoad: "focusOnLoad", customStyles: "customStyles", init: "init", maxCharacter: "maxCharacter", characterText: "characterText", content: "content", tinymceMenubar: "tinymceMenubar" }, outputs: { contentChange: "contentChange", pasteError: "pasteError", escape: "escape", editorFocusOut: "editorFocusOut", editorKeyup: "editorKeyup", editorKeydown: "editorKeydown", editorKeypress: "editorKeypress", editorMouseup: "editorMouseup", editorMouseover: "editorMouseover", editorMousedown: "editorMousedown", editorBlur: "editorBlur", editorClick: "editorClick", editorFocus: "editorFocus", editorChange: "editorChange", editorNodeChange: "editorNodeChange", editorSetContent: "editorSetContent", plainTextKeyup: "plainTextKeyup", loadComplete: "loadComplete" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 8, consts: [["class", "a11y-tooltip", 4, "ngIf"], ["class", "character-count", 3, "ngClass", 4, "ngIf"], [1, "ahe-ui", "form-group", "has-feedback", "rich-text-container", 3, "ngClass"], [4, "ngIf"], ["class", "plain-text-editor", 3, "ngClass", "value", "input", "blur", "paste", 4, "ngIf"], [1, "help-block"], [4, "ngFor", "ngForOf"], [1, "a11y-tooltip"], ["text", "Press ALT + F10 to access the toolbar from the input field. Press Escape to access the input field from the toolbar.", "placement", "right"], ["href", "javascript:void(0)", 1, "skip-link", "ahe-ui-link", 3, "click"], [1, "character-count", 3, "ngClass"], ["class", "character-text", 4, "ngIf"], [1, "character-text"], [3, "content", "noMedia", "imageOnly", "maxCharacter", "basicMode", "toggleRichTextMenuBar", "tinymceMenubar", "elementPath", "init", "hideAllHeaderBars", "isInputBox", "focusOnLoad", "customStyles", "editorKeyup", "editorBlur", "pasteError", "plainTextKeyup", "escape", "editorKeydown", "editorKeypress", "editorMouseup", "editorMousedown", "editorMouseover", "editorChange", "editorFocus", "editorClick", "editorNodeChange", "editorSetContent", "loadComplete", 4, "ngIf"], [3, "content", "noMedia", "imageOnly", "maxCharacter", "basicMode", "toggleRichTextMenuBar", "tinymceMenubar", "elementPath", "init", "hideAllHeaderBars", "isInputBox", "focusOnLoad", "customStyles", "editorKeyup", "editorBlur", "pasteError", "plainTextKeyup", "escape", "editorKeydown", "editorKeypress", "editorMouseup", "editorMousedown", "editorMouseover", "editorChange", "editorFocus", "editorClick", "editorNodeChange", "editorSetContent", "loadComplete"], [1, "plain-text-editor", 3, "ngClass", "value", "input", "blur", "paste"]], template: function EditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EditorComponent_div_0_Template, 4, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, EditorComponent_div_1_Template, 3, 8, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, EditorComponent_div_3_Template, 3, 2, "div", 3);
        ɵngcc0.ɵɵtemplate(4, EditorComponent_textarea_4_Template, 1, 5, "textarea", 4);
        ɵngcc0.ɵɵelementStart(5, "span", 5);
        ɵngcc0.ɵɵtemplate(6, EditorComponent_span_6_Template, 3, 1, "span", 6);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.useA11yTooltip);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCharacterLimit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c3, ctx.showErrors.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useRichText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.useRichText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.showErrors);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc3.A11yTooltipComponent, RichTextEditorComponent], styles: [".plain-text-editor[_ngcontent-%COMP%]{width:100%;resize:vertical}.character-count[_ngcontent-%COMP%]{float:right}.character-count.plain-text[_ngcontent-%COMP%]{top:0}.character-count.below-character-limit[_ngcontent-%COMP%]{color:#b0181e}.a11y-tooltip[_ngcontent-%COMP%]{margin-bottom:10px;display:inline-block}.skip-link[_ngcontent-%COMP%]{position:absolute;left:-9999px}.skip-link[_ngcontent-%COMP%]:focus{position:relative;left:0;outline:0}.plain-text-editor-error[_ngcontent-%COMP%]{border:1px solid #b0181e;outline:0}.rich-text-container[_ngcontent-%COMP%]{clear:both}"], changeDetection: 0 });
EditorComponent.ctorParameters = () => [
    { type: TextUtilityService }
];
__decorate([
    Output()
], EditorComponent.prototype, "contentChange", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "pasteError", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "escape", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorFocusOut", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorKeyup", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorKeydown", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorKeypress", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorMouseup", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorMouseover", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorMousedown", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorBlur", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorClick", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorFocus", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorChange", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorNodeChange", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "editorSetContent", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "plainTextKeyup", void 0);
__decorate([
    Output()
], EditorComponent.prototype, "loadComplete", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "init", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "maxCharacter", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "characterText", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "content", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "useRichText", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "noMedia", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "imageOnly", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "toggleRichTextMenuBar", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "tinymceMenubar", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "elementPath", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "basicMode", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "showCharacterLimit", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "useA11yTooltip", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "errors", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "hideAllHeaderBars", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "isInputBox", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "focusOnLoad", void 0);
__decorate([
    Input()
], EditorComponent.prototype, "customStyles", void 0);
__decorate([
    ViewChild(RichTextEditorComponent)
], EditorComponent.prototype, "richTextEditorComponent", void 0);

var RichTextEditorModule_1;
function getTinymce() {
    return window['tinymce'];
}
const ngxSharedTranslateModule = TranslateModule.forRoot();
let RichTextEditorModule = RichTextEditorModule_1 = class RichTextEditorModule {
    static forRoot(config) {
        return {
            ngModule: RichTextEditorModule_1,
            providers: [{
                    provide: WIRIS_URL,
                    useValue: config.wirisUrl
                },
                {
                    provide: MMS_URL,
                    useValue: config.mmsUrl
                },
                {
                    provide: TINYMCE_SKINS_URL,
                    useValue: config.tinymceSkinsUrl
                },
                {
                    provide: TINYMCE_EXTERNAL_PLUGINS,
                    useValue: config.tinymceExternalPlugins
                },
                {
                    provide: TINYMCE_TOOLBAR,
                    useValue: config.tinymceToolbar
                },
                {
                    provide: TINYMCE_PLUGINS,
                    useValue: config.tinymcePlugins
                },
                {
                    provide: TINYMCE_HIDEA11YCHECKER,
                    useValue: config.hideA11yChecker
                }
            ]
        };
    }
};
RichTextEditorModule.ɵfac = function RichTextEditorModule_Factory(t) { return new (t || RichTextEditorModule)(); };
RichTextEditorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RichTextEditorModule });
RichTextEditorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [{
            provide: TINYMCE,
            useFactory: getTinymce
        }, TextUtilityService], imports: [CommonModule,
        NgxSharedModule,
        ngxSharedTranslateModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextUtilityService, [{
        type: Injectable
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RichTextEditorComponent, [{
        type: Component,
        args: [{ selector: 'mhe-rich-text-editor', template: `<textarea #textarea></textarea>`, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host ::ng-deep [aria-label=\"Font Sizes\"] button{width:65px}"] }]
    }], function () { return [{ type: TextUtilityService }, { type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [TINYMCE]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [WIRIS_URL]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [MMS_URL]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [TINYMCE_SKINS_URL]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [TINYMCE_TOOLBAR]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TINYMCE_EXTERNAL_PLUGINS]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [TINYMCE_PLUGINS]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TINYMCE_HIDEA11YCHECKER]
            }] }, { type: ɵngcc1.Store }]; }, { editorKeyup: [{
            type: Output
        }], editorKeydown: [{
            type: Output
        }], editorKeypress: [{
            type: Output
        }], editorMouseup: [{
            type: Output
        }], editorMouseover: [{
            type: Output
        }], editorMousedown: [{
            type: Output
        }], editorBlur: [{
            type: Output
        }], editorClick: [{
            type: Output
        }], editorFocus: [{
            type: Output
        }], editorChange: [{
            type: Output
        }], editorNodeChange: [{
            type: Output
        }], plainTextKeyup: [{
            type: Output
        }], pasteError: [{
            type: Output
        }], editorSetContent: [{
            type: Output
        }], loadComplete: [{
            type: Output
        }], content: [{
            type: Input
        }], customStyles: [{
            type: Input
        }], hideAllHeaderBars: [{
            type: Input
        }], isInputBox: [{
            type: Input
        }], focusOnLoad: [{
            type: Input
        }], init: [{
            type: Input
        }], maxCharacter: [{
            type: Input
        }], noMedia: [{
            type: Input
        }], imageOnly: [{
            type: Input
        }], toggleRichTextMenuBar: [{
            type: Input
        }], elementPath: [{
            type: Input
        }], basicMode: [{
            type: Input
        }], tinymceMenubar: [{
            type: Input
        }], textarea: [{
            type: ViewChild,
            args: ['textarea', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorComponent, [{
        type: Component,
        args: [{ selector: 'mhe-editor', template: "<div class=\"a11y-tooltip\" *ngIf=\"useA11yTooltip\">\n  <mhe-a11y-tooltip\n    text=\"Press ALT + F10 to access the toolbar from the input field. Press Escape to access the input field from the toolbar.\"\n    placement=\"right\">\n  </mhe-a11y-tooltip>\n  <a href=\"javascript:void(0)\" class=\"skip-link ahe-ui-link\" (click)=\"skipToEditor($event)\">skip to input field</a>\n</div>\n\n<div *ngIf=\"showCharacterLimit\"\n     class=\"character-count\"\n     [ngClass]=\"{'below-character-limit': checkCharacterCount(characterText), 'question-text': characterText, 'plain-text': !useRichText}\">\n  {{maxCharacter-characterCount}}/{{maxCharacter}}\n  <span class=\"character-text\" *ngIf=\"characterText\">{{ characterText }}</span>\n</div>\n<div class=\"ahe-ui form-group has-feedback rich-text-container\"\n     [ngClass]=\"{'has-error': showErrors.length}\">\n  <div *ngIf=\"useRichText\">\n    <mhe-rich-text-editor *ngIf=\"render\"\n                          [content]=\"richValue\"\n                          [noMedia]=\"noMedia\"\n                          [imageOnly]=\"imageOnly\"\n                          [maxCharacter]=\"maxCharacter\"\n                          [basicMode]=\"basicMode\"\n                          [toggleRichTextMenuBar]=\"toggleRichTextMenuBar\"\n                          [tinymceMenubar]=\"tinymceMenubar\"\n                          [elementPath]=\"elementPath\"\n                          [init]=\"init\"\n                          [hideAllHeaderBars]=\"hideAllHeaderBars\"\n                          [isInputBox]=\"isInputBox\"\n                          [focusOnLoad]=\"focusOnLoad\"\n                          [customStyles]=\"customStyles\"\n                          (editorKeyup)=\"onRichTextEditorKeyup($event)\"\n                          (editorBlur)=\"onEditorBlur()\"\n                          (pasteError)=\"onPasteError()\"\n                          (plainTextKeyup)=\"onRichTextEditorPlainTextKeyup($event)\"\n                          (escape)=\"onEscape()\"\n                          (editorKeydown)=\"onEditorKeydown($event)\"\n                          (editorKeypress)=\"onEditorKeypress($event)\"\n                          (editorMouseup)=\"onEditorMouseup($event)\"\n                          (editorMousedown)=\"onEditorMousedown($event)\"\n                          (editorMouseover)=\"onEditorMouseover($event)\"\n                          (editorChange)=\"onEditorChange($event)\"\n                          (editorFocus)=\"onEditorFocus($event)\"\n                          (editorClick)=\"onEditorClick($event)\"\n                          (editorNodeChange)=\"onEditorNodeChange($event)\"\n                          (editorSetContent)=\"onEditorSetContent($event)\"\n                          (loadComplete)=\"onEditorInit($event)\"></mhe-rich-text-editor>\n\n    <mhe-rich-text-editor *ngIf=\"!render\"\n                          [content]=\"richValue\"\n                          [noMedia]=\"noMedia\"\n                          [imageOnly]=\"imageOnly\"\n                          [maxCharacter]=\"maxCharacter\"\n                          [basicMode]=\"basicMode\"\n                          [toggleRichTextMenuBar]=\"toggleRichTextMenuBar\"\n                          [tinymceMenubar]=\"tinymceMenubar\"\n                          [elementPath]=\"elementPath\"\n                          [init]=\"init\"\n                          [hideAllHeaderBars]=\"hideAllHeaderBars\"\n                          [isInputBox]=\"isInputBox\"\n                          [focusOnLoad]=\"focusOnLoad\"\n                          [customStyles]=\"customStyles\"\n                          (editorKeyup)=\"onRichTextEditorKeyup($event)\"\n                          (editorBlur)=\"onEditorBlur()\"\n                          (pasteError)=\"onPasteError()\"\n                          (plainTextKeyup)=\"onRichTextEditorPlainTextKeyup($event)\"\n                          (escape)=\"onEscape()\"\n                          (editorKeydown)=\"onEditorKeydown($event)\"\n                          (editorKeypress)=\"onEditorKeypress($event)\"\n                          (editorMouseup)=\"onEditorMouseup($event)\"\n                          (editorMousedown)=\"onEditorMousedown($event)\"\n                          (editorMouseover)=\"onEditorMouseover($event)\"\n                          (editorChange)=\"onEditorChange($event)\"\n                          (editorFocus)=\"onEditorFocus($event)\"\n                          (editorClick)=\"onEditorClick($event)\"\n                          (editorNodeChange)=\"onEditorNodeChange($event)\"\n                          (editorSetContent)=\"onEditorSetContent($event)\"\n                          (loadComplete)=\"onEditorInit($event)\"></mhe-rich-text-editor>\n  </div>\n\n  <textarea *ngIf=\"!useRichText\"\n            class=\"plain-text-editor\"\n            [ngClass]=\"{'plain-text-editor-error': showErrors.length}\"\n            (input)=\"onPlainTextKeyup($event.target.value)\"\n            (blur)=\"onEditorBlur()\"\n            (paste)=\"onTextAreaPaste($event)\"\n            [attr.maxlength]=\"maxCharacter || null\"\n            [value]=\"plainValue || ''\"></textarea>\n\n  <span class=\"help-block\">\n    <span *ngFor=\"let error of showErrors\">{{ error }} <br/></span>\n  </span>\n</div>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [".plain-text-editor{width:100%;resize:vertical}.character-count{float:right}.character-count.plain-text{top:0}.character-count.below-character-limit{color:#b0181e}.a11y-tooltip{margin-bottom:10px;display:inline-block}.skip-link{position:absolute;left:-9999px}.skip-link:focus{position:relative;left:0;outline:0}.plain-text-editor-error{border:1px solid #b0181e;outline:0}.rich-text-container{clear:both}"] }]
    }], function () { return [{ type: TextUtilityService }]; }, { contentChange: [{
            type: Output
        }], pasteError: [{
            type: Output
        }], escape: [{
            type: Output
        }], editorFocusOut: [{
            type: Output
        }], editorKeyup: [{
            type: Output
        }], editorKeydown: [{
            type: Output
        }], editorKeypress: [{
            type: Output
        }], editorMouseup: [{
            type: Output
        }], editorMouseover: [{
            type: Output
        }], editorMousedown: [{
            type: Output
        }], editorBlur: [{
            type: Output
        }], editorClick: [{
            type: Output
        }], editorFocus: [{
            type: Output
        }], editorChange: [{
            type: Output
        }], editorNodeChange: [{
            type: Output
        }], editorSetContent: [{
            type: Output
        }], plainTextKeyup: [{
            type: Output
        }], loadComplete: [{
            type: Output
        }], useRichText: [{
            type: Input
        }], noMedia: [{
            type: Input
        }], imageOnly: [{
            type: Input
        }], toggleRichTextMenuBar: [{
            type: Input
        }], elementPath: [{
            type: Input
        }], basicMode: [{
            type: Input
        }], showCharacterLimit: [{
            type: Input
        }], useA11yTooltip: [{
            type: Input
        }], errors: [{
            type: Input
        }], hideAllHeaderBars: [{
            type: Input
        }], isInputBox: [{
            type: Input
        }], focusOnLoad: [{
            type: Input
        }], customStyles: [{
            type: Input
        }], init: [{
            type: Input
        }], maxCharacter: [{
            type: Input
        }], characterText: [{
            type: Input
        }], content: [{
            type: Input
        }], tinymceMenubar: [{
            type: Input
        }], richTextEditorComponent: [{
            type: ViewChild,
            args: [RichTextEditorComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RichTextEditorModule, [{
        type: NgModule,
        args: [{
                declarations: [RichTextEditorComponent, EditorComponent],
                imports: [
                    CommonModule,
                    NgxSharedModule,
                    ngxSharedTranslateModule
                ],
                providers: [{
                        provide: TINYMCE,
                        useFactory: getTinymce
                    }, TextUtilityService],
                exports: [RichTextEditorComponent, EditorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RichTextEditorModule, { declarations: function () { return [RichTextEditorComponent, EditorComponent]; }, imports: function () { return [CommonModule,
        NgxSharedModule, ɵngcc4.TranslateModule]; }, exports: function () { return [RichTextEditorComponent, EditorComponent]; } }); })();

const LoadTinymceConfig = '[Tinymce Config] Load Tinymce Config';
class LoadTinymceConfigAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LoadTinymceConfig;
    }
}

class TinymceConfig {
    constructor(d) {
        this.wirisUrl = d.wirisUrl;
        this.mmsUrl = d.mmsUrl;
        this.tinymceSkinsUrl = d.tinymceSkinsUrl;
        this.tinymceExternalPlugins = d.tinymceExternalPlugins;
        this.hideA11yChecker = d.hideA11yChecker;
    }
}

const initialState = {
    wirisUrl: null,
    mmsUrl: null,
    tinymceSkinsUrl: null,
    tinymceExternalPlugins: null,
    hideA11yChecker: false
};
function TinymceConfigReducer(state = initialState, action) {
    switch (action.type) {
        case LoadTinymceConfig:
            return Object.assign({}, action.payload);
        default:
            return state;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { LoadTinymceConfig, LoadTinymceConfigAction, MMS_URL, RichTextEditorModule, TINYMCE, TINYMCE_EXTERNAL_PLUGINS, TINYMCE_HIDEA11YCHECKER, TINYMCE_MENUBAR, TINYMCE_PLUGINS, TINYMCE_SKINS_URL, TINYMCE_TOOLBAR, TextUtilityService, TinymceConfig, TinymceConfigReducer, WIRIS_URL, getTinymce, initialState, ngxSharedTranslateModule, RichTextEditorComponent as ɵa, EditorComponent as ɵb };

